import { AuthService } from './authService';
import { POrderLineDto, POrderDetailsDto } from '../types/porders';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class POrderLineService {
  
  /**
   * Henter alle linjer for en spesifikk ordre
   */
  async getOrderLines(orderNo: number): Promise<POrderLineDto[]> {
    const response = await AuthService.authenticatedGet(`${API_BASE_URL}/porders/${orderNo}/lines`);
    
    if (!response.ok) {
      throw new Error(`Failed to get order lines for order ${orderNo}: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  }

  /**
   * Henter ordre med alle linjer
   */
  async getOrderDetails(orderNo: number): Promise<POrderDetailsDto> {
    const response = await AuthService.authenticatedGet(`${API_BASE_URL}/porders/${orderNo}/details`);
    
    if (!response.ok) {
      throw new Error(`Failed to get order details for order ${orderNo}: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  }

  /**
   * Oppdaterer en ordrelinje
   */
  async updateOrderLine(orderNo: number, lineNo: number, line: Partial<POrderLineDto>): Promise<POrderLineDto> {
    const response = await AuthService.authenticatedPut(
      `${API_BASE_URL}/porders/${orderNo}/lines/${lineNo}`,
      line
    );
    
    if (!response.ok) {
      throw new Error(`Failed to update order line ${lineNo} for order ${orderNo}: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  }
}

export const pOrderLineService = new POrderLineService();
